import React, { useState, useEffect } from 'react';
import toast from 'react-hot-toast';
import Modal from '../shared/Modal';
import TextInput from '../InputComponent/TextInput';
import SelectInput from '../InputComponent/SelectInput';
import TextAreaInput from '../InputComponent/TextAreaInput';
import api from '../../services/ApiService';
import { ENDPOINTS } from '../../constant/ApiEndpoints';

const BookSessionModal = ({ isOpen, onClose, onSave, members, trainers, isLoading }) => {
    const getTodayString = () => new Date().toISOString();
    const getCurrentTimeString = () => new Date().toTimeString();
    const [planError, setPlanError] = useState(null);
    const [activeMember, setActiveMember] = useState(null);

    const initialFormState = {
        memberId: '',
        trainerId: '',
        date: getTodayString(),
        start_time: getCurrentTimeString(),
        sessionType: 'Personal',
        remarks: '',
    };

    const [formData, setFormData] = useState(initialFormState);

    useEffect(() => {
        if (isOpen) {
            setFormData({
                ...initialFormState,
                memberId: '',
                trainerId: '',
            });
        }
    }, [isOpen, members, trainers]);


    const getEndTime = async (memberId) => {
        try {
            let response = await api.get(`${ENDPOINTS.getUserById}/${memberId}`);
            let user = response?.data?.user;
            setActiveMember(user);
            console.log(user);
            
            let havePlan = !!user?.plan?.id
            if (!havePlan) {
                setPlanError(`${user?.name} does not have an active plan. Please assign one.`);
            } else {
                setPlanError(null);
            }
            console.log(`havePlan - ${havePlan}`, user?.plan);
        } catch (e) {
            console.log(e);
        } finally {
            setFormData(prev => ({ ...prev, memberId: memberId }));
        }
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name == 'memberId') {
            getEndTime(value);
            return;
        }
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    // Correct calculation using pure local math
    const calculateEndTime = (date, startTime, durationHours) => {
        if (!date || !startTime || !durationHours) return "";

        // Extract parts
        const [h, m] = startTime.split(":").map(Number);
        const duration = Number(durationHours);

        // Convert start time to minutes
        let totalMinutes = h * 60 + m + duration * 60;

        // Convert back to HH:mm
        let endH = Math.floor(totalMinutes / 60) % 24;
        let endM = totalMinutes % 60;

        return `${endH.toString().padStart(2, "0")}:${endM.toString().padStart(2, "0")}`;
    };

    const formatTo12Hour = (time) => {
        if (!time) return "";
        let [hours, minutes] = time.split(":").map(Number);
        const ampm = hours >= 12 ? "PM" : "AM";
        hours = hours % 12 || 12;
        return `${hours}:${minutes.toString().padStart(2, "0")} ${ampm}`;
    };


    const handleSubmit = async (e) => {
        console.log(formData);
        e.preventDefault();
        console.log(!formData.date);

        if (!formData.memberId || !formData.trainerId || !formData.date || !formData.start_time) {
            toast.error('Please fill all required fields.');
            return;
        }
        if (planError != null) {
            toast.error(planError);
            return;
        }
        if(activeMember?.plan?.access_type != 'session'){
            toast.error("User does not have a Session based plan");
            return;
        }
        console.log(formData.date, formData.start_time, activeMember?.plan?.session_duration);
        
        const endTime = await calculateEndTime(formData.date, formData.start_time, activeMember?.plan?.session_duration) ?? '';
        const member = members.find(m => m?.role.id == formData.memberId);
        const trainer = trainers.find(t => t.role.id == formData.trainerId);
        console.log("endTime->>>>>>>>>>>");
        console.log("endTime:", endTime);
        console.log("Start (24h):", formData.start_time, "=>", formatTo12Hour(formData.start_time));
        console.log("End (24h):", endTime, "=>", formatTo12Hour(endTime)); 
        onSave({
            user_id: formData.memberId,
            memberName: member?.name,
            trainer_id: formData.trainerId,
            trainerName: trainer?.name, 
            date: formData.date,
            start_time: formatTo12Hour(formData.start_time),
            end_time: formatTo12Hour(endTime),  
            remarks: formData.remarks,
        }); 
        setPlanError(null);
        console.log('initialFormState');
        setFormData((prev)=>({...prev, memberId : ''}));
        setActiveMember(null); 
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose} title="Book New Session">
            <form onSubmit={handleSubmit} className="space-y-4">
                <SelectInput label={"Member"} name="memberId" value={formData.memberId} onChange={handleChange} isRequired={true}>
                    <option value="">Select Member</option>
                    {members.map(m => <option key={m.id} value={m.id}>{m.name} - {m?.member_id}</option>)}
                </SelectInput>
                <SelectInput label={"Trainer"} name="trainerId" value={formData.trainerId} onChange={handleChange} isRequired={true}>
                    <option value="">Select Trainer</option>
                    {trainers.map(t => <option key={t.id} value={t.id}>{t.name}</option>)}
                </SelectInput>

                <div className="grid grid-cols-2 gap-4">
                    <TextInput label={"Date"} type="date" name="date" value={formData.date} onChange={handleChange} isRequired={true} min={new Date().toISOString().split("T")[0]} />
                    <TextInput label={"Start Time"} name="start_time" type="time" value={formData.start_time} onChange={handleChange} isRequired={true} />
                    {/* <TextInput disabled={true} label={"End Time"} name="end_time" type="time" value={formData.end_time} onChange={handleChange} /> */}
                </div>
                <TextAreaInput label={"Remarks"} name="remarks" value={formData.remarks} onChange={handleChange} rows="2" />
                <div className="pt-4 flex justify-end gap-3">
                    <button type="button" onClick={onClose} className="px-4 py-2 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300">Cancel</button>
                    <button disabled={isLoading} type="submit" className="px-4 py-2 bg-brand-red text-white rounded-lg hover:bg-red-600">{isLoading ? 'Loading' : 'Book Session'}</button>
                </div>
            </form>
        </Modal>
    );
};

export default BookSessionModal;
